import React from 'react'
import ArrowIcon from '../../atoms/Arrow'
import Text from '../../atoms/Text'
import Button from '../../atoms/GoodFlipButton'
import KidneyScoreImage from '../../../assets/images/kidney_score.webp'
import ZydusLogo from '../../../assets/images/zydus_logo.webp'
import BlueVectorBG from '../../../assets/images/blue_vector_bg.webp'
import ZydusHeader from '../../molecules/ZydusHeader'

const KidneyScoreBridge = ({ onClick = () => {} }) => {
  return (
    <div className="bg-gradient-to-t to-[#EEFFFF] from-[#FFFFFF] h-screen p-5 relative flex flex-col justify-center">
      <ZydusHeader />
      <div className="relative flex items-center justify-center flex-col gap-2 min-h-[344px]">
        <img
          src={BlueVectorBG}
          alt="blue-vector-bg"
          className="absolute top-0 left-0 w-full h-auto object-cover z-0"
        />
        <img
          src={ZydusLogo}
          alt="zydus-logo"
          className=" relative z-10 w-20 h-11"
        />
        <Text
          variant="display"
          size="small"
          className={'!text-center text-text-accent-teal-primary z-10'}
        >
          Know Your Kidney Score in 2 mins
        </Text>
        <Text
          variant="body"
          size="large"
          className={'text-text-secondary !text-center z-10'}
        >
          This quick, expert-designed quiz calculates your Kidney Profile Score
          based on your details and symptoms.
        </Text>
      </div>
      <div className="flex items-center justify-center mt-8 pb-20">
        <img
          src={KidneyScoreImage}
          alt="kidney-score"
          className="w-full h-full object-cover relative max-w-[300px]"
        />
      </div>
      <div className="w-full left-0 fixed bottom-0 p-5">
        <Button
          onClick={onClick}
          title={'See Diagnostic Tests'}
          className={'max-w-6xl mx-auto'}
          type="goodflip_primary"
          leftIcon={null}
          rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
        />
      </div>
    </div>
  )
}

export default KidneyScoreBridge
